import { Component, OnInit, OnDestroy, ViewChild, ElementRef } from "@angular/core";
import { ActivatedRoute, Router, NavigationExtras } from "@angular/router";
import { Modal } from "bootstrap";

import {
  ViewService,
  ConfigService,
  ContainerService,
  Container,
  WasteStreamService,
  WasteStream,
  ContainerTypeService,
  ContainerType,
  AuthService,
  Person,
  capitalize,
  ManifestService,
  UnshippedManifest,
  Item,
  PeopleService,
  UnitService,
  Facility,
  FacilityService,
  TsdfCodeService,
  TsdfCode,
  OwnerChargeInfo,
  ItemService,
} from "../../common";

@Component({
  selector: "container-edit",
  templateUrl: "./container-edit.component.html",
  styleUrls: ["./container-edit.component.css"],
  standalone: false,
})
export class ContainerEdit implements OnInit, OnDestroy {
  container: Container;
  subscriptions: any[];
  errorMsg: string;
  wasteType: string = "";
  manifestFilter: string = "";
  containerNumber: string;
  trackingNumber: string;
  caiForPersonTest: string;
  physicalStateOptions: string[];
  searchCriteria: string;
  showList: boolean;
  people: Person[];
  formChanged: boolean;
  containerTypes: ContainerType[];
  facilitiescompanies: Facility[];
  tsdfCodes: TsdfCode[];
  wasteStreams: WasteStream[];
  user: Person;
  unshippedManifests: UnshippedManifest[];
  moveModal: Modal | undefined;
  copyModal: Modal | undefined;
  copyQty: number = 1;
  items: Item[];
  unitsV: string[];
  unitsW: string[];
  @ViewChild("aform") aForm: ElementRef;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private viewService: ViewService,
    private authService: AuthService,
    private configService: ConfigService,
    private unitService: UnitService,
    private manifestService: ManifestService,
    private containerService: ContainerService,
    private wasteStreamService: WasteStreamService,
    private containerTypeService: ContainerTypeService,
    private facilityService: FacilityService,
    private tsdfService: TsdfCodeService,
    private peopleService: PeopleService,
    public itemService: ItemService
  ) {
    this.subscriptions = [];

    viewService.setViewData({ pageTitle: "Container Editor" });

    const manifestSpec = this.router.getCurrentNavigation().extras.state as {
      trackingNumber: string;
      type: string;
    };
    if (manifestSpec) {
      this.trackingNumber = manifestSpec.trackingNumber;
      this.wasteType = manifestSpec.type;
    }
    this.configService.get(true).subscribe((appConfig) => {
      this.physicalStateOptions = appConfig.physicalStateOptions;
    });
    this.facilityService.getActive().subscribe((facilities) => {
      this.facilitiescompanies = facilities.data.map((u) => u.company);
    });
    this.containerTypeService.getActive().subscribe((ct) => {
      this.containerTypes = ct.data;
    });
    this.tsdfService.getActive().subscribe((codes) => {
      this.tsdfCodes = codes.data;
    });
    this.unitService.getActive().subscribe((units) => {
      this.unitsW = units.data
        .filter((u) => u.container && u.unitType === "W")
        .map((u) => u.abbreviation);
      this.unitsV = units.data
        .filter((u) => u.container && u.unitType === "V")
        .map((u) => u.abbreviation);
    });
  }

  updateSearchCriteria(criteria: string) {
    this.container.owner = criteria;

    this.peopleService
      .filterBy({
        search: this.container.owner,
      })
      .subscribe(
        (people) => {
          this.people = people;
        },
        (error) => (this.errorMsg = error)
      );
  }
  setFacility(facility: Facility) {
    this.container.facilityName = facility.company;
  }
  setDisposalCode(tsdf: TsdfCode) {
    this.container.tsdfDisposalCode = tsdf.code;
  }
  setOwner(user: Person) {
    this.container.owner = user.cai;
    this.container.ownerName = user.displayName;
    this.container.phone = user.phone;
    this.container.office = user.office;
    this.containerService.chargeInfo(user.cai).subscribe((info: OwnerChargeInfo) => {
      this.container.chargeCode = info?.chargeCode;
      this.container.labNo = info?.labNumber;
    });
  }
  setEnteredBy(user: Person) {
    this.container.enteredBy = user.cai;
    this.container.enteredByName = user.displayName;
  }

  ngOnInit(): void {
    this.subscriptions.push(
      this.route.params.subscribe((params) => {
        this.containerNumber = params["containerId"];

        this.wasteStreamService.getActive().subscribe((wasteStreams) => {
          this.wasteStreams = wasteStreams.data;
          if (this.containerNumber) {
            this.containerService.get(this.containerNumber).subscribe((container) => {
              if (container.canEdit) {
                this.container = container;
                this.itemService.firlterByContainer(this.containerNumber).subscribe((response) => {
                  this.items = response;
                  this.container.itemsWeight = this.items.reduce((a, b) => +a + +b.weight, 0);
                });
                this.trackingNumber = container.trackingNumber;
                this.wasteType = container.wasteType;
                this.viewService.setViewData({
                  pageTitle: `Modifying ${container.containerNumber}`,
                });
                if (!this.trackingNumber) {
                  this.openMove(this.wasteType);
                }
              } else {
                this.viewService.back();
              }
            });
          } else {
            this.reset(this.trackingNumber, this.wasteType, this.container);
            setTimeout(() => {
              this.viewService.setViewData({ pageTitle: `Adding a new Container` });
            });
          }
        });
      })
    );
  }
  reset(trackingNumber?: string, type?: string, container?: any) {
    this.container = new Container();
    this.container.volumeUnits = "GA";
    this.container.weightUnits = "LB";

    this.authService.getCurrenUser().subscribe((user: Person) => {
      this.setEnteredBy(user);
      this.container.startDate = new Date();
      this.container.open = true;
      if (container) {
        this.container = container;
        this.container.id = 0;
      }
      if (trackingNumber) {
        this.container.trackingNumber = capitalize(trackingNumber);
        this.container.wasteType = type;
        if (this.container.wasteType !== "Bulk") {
          this.setWasteStream(this.wasteStreams.find((ws) => ws.name === this.wasteType));
        }
      } else if (!container && !trackingNumber) {
        this.openMove();
      }
    });
  }

  navigateToAddItem() {
    if (!this.formChanged || confirm("Do you wish to continue with unsaved changes?")) {
      const navigationExtras: NavigationExtras = {
        state: {
          containerNumber: this.containerNumber,
          wasteType: this.container.wasteType,
          streamName: this.container.streamName,
          weightUnits: this.container.weightUnits,
        },
      };
      this.router.navigate(["items/new"], navigationExtras);
    }
  }

  copyOpen() {
    setTimeout(() => {
      if (!this.copyModal)
        this.copyModal = new Modal(document.getElementById("copyModal"), {
          keyboard: false,
          backdrop: "static",
        });
      this.copyModal.show();
    });
  }
  copyClose() {
    this.copyModal?.toggle();
  }
  copyApply() {
    if (!this.formChanged || confirm("Do you wish to continue with unsaved changes?")) {
      let copy = { ...this.container } as Container;
      copy.id = 0;
      this.containerService.save(copy, this.copyQty).subscribe(
        (ctn) => {
          this.errorMsg = "";
          this.viewService.back();
        },
        (error) => (this.errorMsg = error)
      );
      this.copyModal?.toggle();
    }
  }

  save() {
    this.formChanged = false;
    this.containerService.save(this.container).subscribe(
      (ctn) => {
        this.errorMsg = null;
        if (this.container.isNew) {
          this.router.navigate([`containers/${ctn.containerNumber}/edit`]);
        }
      },
      (error) => (this.errorMsg = error)
    );
  }

  isonNewPage() {
    return this.router.url.includes("/news");
  }

  approveContainer() {
    const msg = `Are you sure you want to ${
      this.container.approved ? "Decline" : "Approve"
    } this Container?`;
    if (window.confirm(msg)) {
      this.containerService.approve(this.container.id, !this.container.approved).subscribe(
        () => {
          this.container.approved = !this.container.approved;
        },
        (error) => (this.errorMsg = error)
      );
    }
  }

  closeContainer() {
    const msg = `Are you sure you want to ${
      this.container.open ? "Close" : "Re-Open"
    } this Container?`;
    if (window.confirm(msg)) {
      this.containerService.close(this.container.id, !this.container.open).subscribe(
        () => {
          this.container.open = !this.container.open;
        },
        (error) => (this.errorMsg = error)
      );
    }
  }

  openMove(type?: string) {
    setTimeout(() => {
      if (!this.moveModal)
        this.moveModal = new Modal(document.getElementById("moveModal"), {
          keyboard: false,
          backdrop: "static",
        });
      this.moveModal.show();
    });
    this.selectType(type);
  }

  selectType(type: string, filter?: string, page?: number) {
    this.wasteType = type;
    this.unshippedManifests = null;
    if (type) {
      const search = type + (filter ? ";" + filter : "");
      this.manifestService.getUnshipedManifests({ search, page }).subscribe((mans) => {
        this.unshippedManifests = mans;
      });
    }
  }

  pageMove(page: number) {
    this.selectType(this.wasteType, this.manifestFilter, page);
  }
  filterMove(criteria: string, event: Event) {
    if (event) {
      event.preventDefault();
    }
    let currentValue = criteria ? criteria : "";
    let lastValue = this.manifestFilter ? this.manifestFilter : "";

    if (currentValue === lastValue) return; //prevent multiple search commands using same criteria

    this.manifestFilter = currentValue;

    this.selectType(this.wasteType, this.manifestFilter);
  }

  selectMove(manifest: UnshippedManifest) {
    if (this.container.isNew) {
      this.container.setManifest(manifest);
      if (manifest.wasteType !== "Bulk") {
        this.setWasteStream(this.wasteStreams.find((ws) => ws.name === this.wasteType));
      }
    } else {
      // If the Container already exists, apply the move action
      this.containerService.move(this.container.id, manifest.trackingNumber).subscribe(
        () => {
          this.errorMsg = "";
          this.container.setManifest(manifest);
        },
        (error) => (this.errorMsg = error)
      );
    }

    this.moveModal?.toggle();
    this.errorMsg = "";
  }

  closeMove() {
    if (!this.container.trackingNumber) {
      this.viewService.back();
    }
    this.moveModal?.toggle();
  }

  setWasteStream(ws: WasteStream) {
    console.log(ws);
    this.container.streamName = ws.name;
    this.container.dotDescription = ws.dotDescription;
    this.container.containerDetail = ws.containerDetail;
    this.container.corrosive = ws.corrosive;
    this.container.ignitable = ws.ignitable;
    this.container.reactive = ws.reactive;
    this.container.toxic = ws.toxic;
    this.container.tsdfDisposalCode = ws.tsdfCode;
    this.container.tsdfProfile = ws.tsdfProfile;
    this.container.ergNumber = ws.ergNumber;
    this.container.facilityName = ws.facility;
    this.container.hm = ws.hm;
    this.container.mgmtMethodCode = ws.mgmtCode;
    this.container.physicalStateId = ws.physicalState;
    this.container.stateWasteCode = ws.stateWasteCode;
    this.container.wasteCode01 = ws.wasteCode01;
    this.container.wasteCode02 = ws.wasteCode02;
    this.container.wasteCode03 = ws.wasteCode03;
    this.container.wasteCode04 = ws.wasteCode04;
    this.container.wasteCode05 = ws.wasteCode05;
    this.container.wasteCode06 = ws.wasteCode06;
    this.container.wasteCode07 = ws.wasteCode07;
    this.container.wasteCode08 = ws.wasteCode08;
    this.container.wasteCode09 = ws.wasteCode09;
    this.container.wasteCode10 = ws.wasteCode10;
  }

  remove(id: number) {
    if (confirm("Confirm you want to remove this Container?")) {
      this.containerService.remove(id).subscribe(
        () => {
          this.viewService.back();
        },
        (error) => (this.errorMsg = error)
      );
    }
  }
  wcChanged(event) {
    if (event.target.value.length > 3) {
      const wcId = parseInt(event.target.name.substring(9, 11)) + 1;
      const wc = "wasteCode" + wcId.toString().padStart(2, "0");
      const ele = this.aForm.nativeElement[wc];
      if (ele) {
        ele.focus();
      }
    }
  }
  ngOnDestroy() {
    console.log(this.container);

    this.subscriptions.forEach((x) => x.unsubscribe());
  }
}
